import React, { useEffect, useState } from "react";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import CustomTable from "./../../component/CustomTable";
import Select from "react-select";
import Common from "./../../common.json";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

export default function Futurestock() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const foptions = [
    { label: "FUTIDX", value: "FUTIDX" },
    { label: "FUTSTK", value: "FUTSTK" },
  ];
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [tblData, settblData] = useState(false);
  const [getStock, setgetStock] = useState(false);
  const [column, setcolumn] = useState(1);
  const [fututevalue, setfututevalue] = React.useState(false);
  const [futureDate, setfutureDate] = React.useState(false);
  const [symbol, setsymbol] = React.useState(false);
  const [error, seterror] = useState({
    futureerr: "",
    dateerr: "",
    symbolerr: "",
  });

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getFuturePriceList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.response);
        setgetStock(response.data.response.getStock);
      },
      mobile,
      web_token
    );
  }, [column, mobile, web_token]);

  const getDate = (event) => {
    setfutureDate(event?.value);
  };
  const getSymbol = (event, value) => {
    if (value) {
      const getsymbol = event.value ? event.value : "";
      setsymbol(getsymbol);
    }
  };

  const futureUpdate = (event) => {
    const newvalue = event.value;
    setfututevalue(newvalue);
    if (newvalue === "FUTIDX") {
      setgetStock(globaldata.getStock);
    } else {
      let stockdt = globaldata.getkStock;
      setgetStock(stockdt);
    }
  };
  const getUpdatedData = () => {
    let futureerr = "";
    let dateerr = "";
    let symbolerr = "";
    let status = 1;

    if (fututevalue === false) {
      futureerr = "Future Option is required";
      status = 0;
    }
    if (futureDate === false) {
      dateerr = "Future Date is required";
      status = 0;
    }
    if (symbol === null || symbol === false) {
      symbolerr = "Future Symbol is required";
      status = 0;
    }
    seterror({ futureerr: futureerr, dateerr: dateerr, symbolerr: symbolerr });
    if (status === 1) {
      setLoading(true);
      RestService.getFutureStockList(
        function (res) {
          setLoading(false);
          const response = JSON.parse(res);
          settblData(response.data.response);
        },
        mobile,
        web_token,
        fututevalue,
        futureDate,
        symbol
      );
    }
  };
  return (
    <>
      <GlobalHelmet {...Common?.futurePricePattern} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Future Price Pattern" />

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="row">
                          <div className="col-xl-3 col-6 pt-2">
                            {foptions ? (
                              <>
                                <label className="font-bold">
                                  Select Future Option
                                </label>
                                <Select
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                  menuPosition={"fixed"}
                                  onChange={futureUpdate}
                                  options={foptions}
                                  name="stock_id"
                                  className=""
                                />

                                <span className="error">
                                  {error.futureerr ? error.futureerr : ""}{" "}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="col-xl-3 col-6 pt-2">
                            {globaldata.expDate ? (
                              <>
                                <label className="font-bold">Select Date</label>
                                <Select
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                  menuPosition={"fixed"}
                                  onChange={getDate}
                                  options={globaldata.expDate}
                                  name="stock_id"
                                  className=""
                                />

                                <span className="error">
                                  {error.dateerr ? error.dateerr : ""}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="col-xl-3 col-6 pt-2">
                            {getStock ? (
                              <>
                                <label className="font-bold">
                                  Select Symbol
                                </label>
                                <Select
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                  menuPosition={"fixed"}
                                  onChange={getSymbol}
                                  options={getStock}
                                  name="stock_id"
                                  className=""
                                />

                                <span className="error">
                                  {error.symbolerr ? error.symbolerr : ""}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-xl-2 col-6 pt-2">
                            <div className="mt-4">
                              <button
                                onClick={getUpdatedData}
                                className="btn btn-success"
                              >
                                Get Data
                              </button>{" "}
                              &nbsp;
                              <button
                                className="btn btn-success"
                                title="Reload Page"
                                onClick={refreshPage}
                              >
                                <i className="fa fa-refresh"></i>
                              </button>
                            </div>
                          </div>

                          <div className="col-12 pt-4">
                            {!tblData.getDetails ? (
                              ""
                            ) : (
                              <>
                                <CustomTable
                                  key={column.future_stock_id}
                                  columndata={
                                    tblData.setColumn ? tblData.setColumn : ""
                                  }
                                  marketdata={
                                    tblData.getDetails ? tblData.getDetails : ""
                                  }
                                  redirectlink="/stocks/"
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
